<template>
   <form>
      <div class="form-group">
         <div class="row" v-if="errorMssg != null">
            <div class="col-md-12 error_text">
               <p style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</p>
            </div>
         </div>

         <div class="row">
            <div class="col-sm-6 form-col rg-form">
               <label for="birth_date" class="form-label">Fecha de nacimiento *</label>
               <set-date id="birth_date" @set="function(d){model.birth_date = d}"></set-date>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="phone" class="form-label">Teléfono a 10 dígitos *</label>
               <input id="phone" type="text" v-model="model.phone" class="form-control" required maxlength="10">
            </div>
            <div class="col-sm-12 mb-10px mt-20px">
               <p class="bold-inline small-margin mt-2 form-label">Según aplique, selecciona un banco, ingresa el IBAN, o bien,
                  el Account Number de alguna de tus cuentas verificadas para la realización de operaciones:
               </p>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="bank_id" class="form-label">Banco registrado</label>
               <select id="bank_id" v-model="model.bank_id" class="form-control">
                  <option v-for="bank in banks" :value="bank.id" :key="bank.id">{{ bank.name }}</option>
               </select>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="iban" class="form-label">IBAN</label>
               <input id="iban" type="text" v-model="model.iban" class="form-control" >
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="account" class="form-label">Account number</label>
               <input id="account" type="text" v-model="model.account" class="form-control" >
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import SetDate from "@components/shared/SetDate";
export default {
   name: "SLRPerson2",
   components: {SetDate},
   props: {
      banks: {
         type: Array,
         required: true,
      },
   },
   data() {
      return {
         model: {
            birth_date: null,
            phone: null,
            bank_id: null,
            iban: null,
            account: null,
         },
         errorMssg: null,
      }
   },
   methods: {
      checkForm(){
         this.errorMssg = null
         return this.validateFields();
      },
      getPayload(){
         return {
            birth_date: this.model.birth_date,
            phone: this.model.phone,
            bank_id: this.model.bank_id,
            iban: this.model.iban,
            account: this.model.account,
         }
      },
      validateFields(){
         let missing = []
         if(this.model.birth_date == null){
            missing.push('Fecha de nacimiento')
         }
         if(this.model.phone == null){
            missing.push('Teléfono registrado')
         }
         if(this.model.bank_id == null && this.model.iban == null && this.model.account == null){
            missing.push('Establece al menos alguno de los siguientes: Banco registrado, IBAN o Account number')
         }
         if(missing.length > 0){
            this.errorMssg = `Por favor verifica los siguientes campos: ${missing.join(', ')}`
            return false
         }
         return true
      },
   },
}
</script>